import { useSelector, useAppDispatch } from 'rahtab-redux';
import { orderingMerchandiseSelector } from 'rahtab-redux/slices/merchandiseOrderingSlice';
import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { listingSelector, setViewerOrderLimit } from 'rahtab-redux/slices/listingsSlice';

export default function useListing(id: string) {
  const dispatch = useAppDispatch();
  const listing = useSelector(listingSelector(id));
  const merchandise = useSelector(orderingMerchandiseSelector(listing.merchandiseId));
  const [_, { loading }] = useFetchCallType<number>('GetPermittedAmount', {
    params: `OfferCode=${id}`,
    onCompleted: (value) => {
      dispatch(setViewerOrderLimit({ id, value }));
    },
  });

  return { called: true, loading, data: { ...merchandise, ...listing } };
}
